module.exports = __webpack_public_path__ + "img/fruit-pears-190x100.0fa80a08.jpg";